/* eslint-disable*/
import axios from "axios";
import { get, post, getImg, getFile, postFile } from "./http";

// =====================================================================> 登陆页 API
/**
 * 登录（POST）
 * 需要传入三个参数
 * username：用户名
 * password：密码
 * captcha：验证码
 * @param {URLSearchParams} params
 * @returns
 */
export const login = (params) => post(`login`, params);

/**
 * 获取验证码（GET）
 * 需要传入一个随机数
 * 返回blob数据，需手动渲染
 * 注意检查cookie是否可以跨域，否则验证码会失效
 * @param {number} v
 * @returns
 */
export const getCaptcha = (v) => getImg(`captcha?v = ${v}`);

// =====================================================================> 全局 API
/**
 * 检查登陆状态（GET）
 * @returns
 */
export const checkState = () => get(`yj/mine`);

/**
 * 退出登录（POST）
 * @returns
 */
export const logout = () => get(`yj/logout`);

/**
 * 获取图片（GET）
 * 需要传入url
 * 返回blob数据，需手动渲染
 * 注意检查cookie是否可以跨域，否则图片会失效
 * @param {string} path
 * @returns
 */
export const getImage = (path) => getImg(`${path}`);

// =====================================================================> 首页 API
/**
 * 用于首页初始化（GET)
 * 返回值说明:
 * inform: 广播消息
 * l_name: 用户姓名
 * l_username: 用户编号
 * l_role: 用户角色
 * l_roleId: 角色ID  [1:系统管理员 2:院系领导 3:教师 4:任课教师 5:学生]
 * 如果是学生的话还有以下参数
 * l_grade: 年级
 * l_major: 专业
 * l_class: 班级
 * @returns
 */
export const initHome = () => get(`yj/home`);

/**
 * 首页仪表盘统计（合同、申请、承接单位分布）
 * GET yj/home/stats
 */
export const getDashboardStats = () => get(`yj/home/stats`);

// =====================================================================> 作业记录页 API
/**
 * 获取个人作业列表（GET）
 * 需传入的参数
 * limit：每页的记录条数
 * page：当前页码
 * @param {URLSearchParams} params
 * @returns
 */
export const getMyWorkList = (params) => get(`yj/mine/list`, params);

/**
 * 获取学生个人作业详情（GET）
 * 需传入的参数
 * id: 作业ID
 * @param {URLSearchParams} params
 * @returns
 */
export const getStuDetail = (params) => get(`yj/detail-stu`, params);

// =====================================================================> 章节视频页 API

/**
 * 获取课程列表（GET）
 * @returns
 */
export const initSubject = () => get(`yj/subject`);

/**
 * 获取服务内容列表（下拉用，GET）
 * @returns
 */
export const initServiceContent = () => get(`yj/service-content`);

/**
 * 获取服务内容分页列表（GET）
 * @param {URLSearchParams} params
 * @returns
 */
export const getServiceContentList = (params) =>
  get(`yj/service-content/listServiceContent`, params);

/**
 * 添加服务内容（POST）
 * @param {URLSearchParams} params
 * @returns
 */
export const addServiceContent = (params) =>
  post(`yj/service-content-add/add`, params);

/**
 * 删除服务内容（POST）
 * @param {URLSearchParams} params
 * @returns
 */
export const delServiceContent = (params) =>
  post(`yj/service-content/deleteServiceContent`, params);

/**
 * 修改服务内容（POST）
 * @param {URLSearchParams} params id, name
 * @returns
 */
export const updateServiceContent = (params) =>
  post(`yj/service-content/updateServiceContent`, params);

/**
 * 获取个人作业列表（GET）
 * 需传入的参数
 * limit：每页的记录条数
 * page：当前页码
 * @param {URLSearchParams} params
 * @returns
 */
export const getVideo = (params) => get(`yj/video/video`, params);

/**
 * 上传视频(POST)
 * @param {URLSearchParams} params
 * @returns
 */
export const addVideo = (data) => postFile(`yj/subject/add`, data);

/**
 * 上传资源(POST)
 * @param {URLSearchParams} params
 * @returns
 */
export const addSource = (data) => postFile(`yj/subject/addSource`, data);

/**
 * 获取课程列表（GET）
 * 需传入的参数
 * limit：每页的记录条数
 * page：当前页码
 * @param {URLSearchParams} params
 * @returns
 */
export const getSubjectList = (params) =>
  get(`yj/subject/listSubject`, params);

/**
 * 获取可播放章节列表（GET）
 * 需传入的参数
 * limit：每页的记录条数
 * page：当前页码
 * @param {URLSearchParams} params
 * @returns
 */
export const getVideoList = (params) => get(`yj/video/listVideo`, params);

/**
 * 获取可下载资源列表（GET）
 * 需传入的参数
 * @param {URLSearchParams} params
 * @returns
 */
export const getSourceList = (params) => get(`yj/video/getSourceList`, params);

/**
 * 获取可播放章节列表（GET）
 * 需传入的参数
 * limit：每页的记录条数
 * page：当前页码
 * @param {URLSearchParams} params
 * @returns
 */
export const searchVideoList = (params) =>
  get(`yj/video/getVideoList`, params);

/**
 * 进行签到（GET）
 * 需传入的参数
 * videoId: 视频ID
 * @param {URLSearchParams} params
 * @returns
 */
export const VideoSign = (params) => get(`yj/video/sign`, params);

/**
 * 查看签到表（GET）
 * 需传入的参数
 * videoId: 视频ID
 * SubjectId: 课程ID
 * keyUserName: 用户名
 * KeyName: 姓名
 * @param {URLSearchParams} params
 * @returns
 */
export const getSignList = (params) => get(`yj/video/listSign`, params);

/**
 * 删除课程
 * 请求方法: POST
 */
export const delSub = (params) => post(`yj/subject/deleteSubject`, params);

/**
 * 删除视频
 * 请求方法: POST
 */
export const delVideo = (params) => post(`yj/subject/deleteVideo`, params);

/**
 * 删除资源
 * 请求方法: POST
 */
export const delSource = (params) => post(`yj/subject/deleteSource`, params);

/**
 * 添加课程（POST）
 * 需传入的参数
 * name: 奖项名
 * @param {URLSearchParams} params
 * @returns
 */
export const addSubject = (params) => post(`yj/subject-add/add`, params);

// =====================================================================> 作业上传页 API

/**
 * 获取可上传作业列表（GET）
 * 需传入的参数
 * limit：每页的记录条数
 * page：当前页码
 * @param {URLSearchParams} params
 * @returns
 */
export const getWorkList = (params) => get(`yj/upload/listWork`, params);

/**
 * 上传作业（POST）
 * 需传入的参数
 * WorkId: 作业ID
 * WorkName: 作业名
 * WorkTime: 2021-02-04 时间
 * WorkPlace: 作业级别
 * file: (二进制)
 * @param {FormData} data
 * @returns
 */
export const uploadWork = (data) => postFile(`yj/upload/upload`, data);

// =====================================================================> 作业审核页 API
/**
 * 初始化查询参数（GET）
 * 返回的参数有
 * grade：年级列表
 * major：专业列表
 * @returns
 */
export const initReview = () => get(`yj/review`);

/**
 * 获取未审核的作业列表（GET）
 * 需传入的参数
 * limit: 每页的记录条数
 * page: 当前页码
 * gradeId: 年级id（可选）
 * majorId: 专业id（可选）
 * classId: 班级id（可选）
 * keyUsername: 学号（可选）
 * keyName: 姓名（可选）
 * keyWorkName: 作业名（可选）
 * @param {URLSearchParams} params
 * @returns
 */
export const getReviewWorkList = (params) => get(`yj/review/list`, params);

/**
 * 学生作业分数批改（GET）
 * 需传入的参数
 * id：作业id
 * score: 学生分数score
 * @param {URLSearchParams} params
 * @returns
 */
export const WorkReview = (params) => get(`yj/review/review`, params);

// =====================================================================> 班级信息管理 API

/**
 * 初始化查询参数（GET）
 * 返回的参数有
 * grade：年级列表
 * major：专业列表
 * @returns
 */
export const initManageClass = () => get(`yj/class-management`);

/**
 * 获取班级列表（GET）
 * 需传入的参数
 * gradeId：年级ID
 * majorId：专业ID
 * @param {URLSearchParams} params
 * @returns
 */
export const getNewClassList = (params) =>
  get(`yj/class-management/listClass`, params);

/**
 * 获取教师班级列表（GET）
 * 需传入的参数
 * limit: 每页的记录条数
 * page: 当前页码
 * gradeId: 年级id（可选）
 * majorId: 专业id（可选）
 * classId: 班级id（可选）
 * classNo: 班级号码（可选）
 * teacherId: 教师id（可选）
 * teaName：教师名字（可选）
 * className：班级全名（可选）
 * order: 排序方式（可选）
 * field: 排序字段（可选）
 * @param {URLSearchParams} params
 * @returns
 */
export const getInsClassList = (params) =>
  get(`yj/class-management/list`, params);

/**
 * 解除教师与班级的联系
 * 请求方法: POST
 * classIds[]: 69119132
 */
export const delClass = (params) => post(`yj/class-management/delete`, params);

// =====================================================================> 系统设置页 API
/**
 * 修改密码（POST）
 * 需要传入三个参数
 * old-pass：旧密码
 * new-pass：新密码
 * new-pass-v：确认密码
 * @param {URLSearchParams} params
 * @returns
 */
export const updatePass = (params) => post(`yj/password/update`, params);

/**
 * 上传用户头像
 * @param {FormData} formData 字段名 file
 */
export const uploadAvatar = (formData) => postFile(`yj/avatar/upload`, formData);

/** 清除自定义头像，恢复默认 */
export const removeAvatar = () => post(`yj/avatar/remove`);

// =====================================================================> 管理学生作业 API
/**
 * 初始化查询参数（GET）
 * 返回的参数有
 * grade：年级列表
 * major：专业列表
 * @returns
 */
export const initQueryStu = () => get(`yj/query-stu`);

/**
 * 获取学生作业列表（GET）
 * 需传入的参数
 * limit: 每页的记录条数
 * page: 当前页码
 * gradeId: 年级id（可选）
 * majorId: 专业id（可选）
 * classId: 班级id（可选）
 * keyUsername: 学号（可选）
 * keyName: 姓名（可选）
 * keyWorkName: 作业名（可选）
 * @param {URLSearchParams} params
 * @returns
 */
export const getStuWorkList = (params) => get(`yj/query-stu/list`, params);

/**
 * 导出学生作业表格文件（GET）
 * 需传入的参数
 * gradeId: 年级id（可选）
 * majorId: 专业id（可选）
 * classId: 班级id（可选）
 * keyUsername: 学号（可选）
 * keyName: 姓名（可选）
 * keyWorkName: 作业名（可选）
 * @param {URLSearchParams} params
 * @returns
 */
export const exportStuWorkXLS = (params) =>
  getFile(`yj/query-stu/exportXLS`, params);

/**
 * 导出学生作业表格文件（GET）
 * 需传入的参数
 * gradeId: 年级id（可选）
 * majorId: 专业id（可选）
 * classId: 班级id（可选）
 * keyUsername: 学号（可选）
 * keyName: 姓名（可选）
 * keyVideoName: 章节名（可选）
 * @param {URLSearchParams} params
 * @returns
 */
export const exportStuSignXLS = (params) =>
  getFile(`yj/video/exportXLS`, params);

/**
 * 导出课程附件（GET）
 * @param {URLSearchParams} params
 * @returns
 */
export const exportSubjectPDF = (params) =>
  getFile(`yj/subject/exportPDF`, params);

/**
 * 导出学生作业图片压缩包（GET）
 * 需传入的参数
 * gradeId: 年级id（可选）
 * majorId: 专业id（可选）
 * classId: 班级id（可选）
 * keyUsername: 学号（可选）
 * keyName: 姓名（可选）
 * keyWorkName: 作业名（可选）
 * @param {URLSearchParams} params
 * @returns
 */
export const exportStuWorkZIP = (params) =>
  getFile(`yj/query-stu/exportZIP`, params);

/**
 * 获取班级列表（GET）
 * 需传入的参数
 * gradeId：年级ID
 * majorId：专业ID
 * @param {URLSearchParams} params
 * @returns
 */
export const getClassList = (params) => get(`yj/query-stu/listClass`, params);

/**
 * 删除学生作业（GET）
 * 需传入的参数
 * id：作业id
 * @param {URLSearchParams} params
 * @returns
 */
export const delStuWork = (params) => get(`yj/query-stu/del`, params);

/**
 * 更新作业图片（POST）
 * 需传入的参数
 * id: 项目ID
 * file: (二进制)
 * @param {FormData} data
 * @returns
 */
export const updateWorkImg = (data) =>
  postFile(`yj/query-stu/updateImg`, data);

// =====================================================================> 公告组件 API
/**
 * 添加公告（POST）
 * 需要传入的参数
 * title: 标题
 * content: 内容
 * @param {URLSearchParams} params
 * @returns
 */
export const addInform = (params) => post(`yj/home/informadd`, params);

/**
 * 删除公告（POST）
 * 需要传入的参数
 * id：该项id
 * @param {URLSearchParams} params
 * @returns
 */
export const delInform = (params) => post(`yj/home/informdel`, params);

/**
 * 获取展示的作业列表（GET）
 * 需传入的参数
 * limit: 每页的记录条数
 * page: 当前页码
 * @param {URLSearchParams} params
 * @returns
 */
export const getInformList = (params) => get(`yj/home/informlist`, params);

// =====================================================================> 作业管理 API
/**
 * 获取全部作业列表（GET）
 * 需传入的参数
 * limit: 每页的记录条数
 * page: 当前页码
 * type: 0：全部 1:学生 2:教师 作业类型
 * key: 关键词
 * order: desc
 * @param {URLSearchParams} params
 * @returns
 */
export const getAllWorkList = (params) => get(`yj/work/list`, params);

/**
 * 导出课程附件（GET）
 * @param {URLSearchParams} params
 * @returns
 */
export const exportSubjectPDF1 = (params) =>
  getFile(`yj/work/exportPDF`, params);

// api.js 中的 updateWorkContent 函数应该这样修改
export const updateWorkContent = (params) => {
  // 判断是 FormData 还是 URLSearchParams
  if (params instanceof FormData) {
    return postFile(`yj/work/update`, params);
  } else {
    return post(`yj/work/update`, params);
  }
};

/**
 * 删除作业（POST）
 * 需传入的参数
 * ids: 作业的ID 「List」
 * @param {URLSearchParams} params
 * @returns
 */
export const delwork = (params) => post(`yj/work/delete`, params);

// 修改原有的addwork方法，支持FormData
export const addwork = (params) => {
  // 判断是 FormData 还是 URLSearchParams
  if (params instanceof FormData) {
    return postFile(`yj/work-add/add`, params);
  } else {
    return post(`yj/work-add/add`, params);
  }
};

/** 抄送候选人（管理员/部门经理） */
export const getCcCandidates = (params) => get(`yj/work/ccCandidates`, params);

/** 某合同当前抄送人 */
export const getContractCcList = (params) => get(`yj/work/ccList`, params);

/** 单独更新抄送人 */
export const updateContractCc = (params) => post(`yj/work/updateCc`, params);

/**
 * 检查是否已存在同名项目（GET）
 * @param {Object|URLSearchParams} params WorkName
 * @returns
 */
export const checkWorkName = (params) => get(`yj/work-add/checkWorkName`, params);

/**
 * 获取OCR开关状态
 * @returns
 */
export const getOcrStatus = () => {
  return get(`yj/work-add/getOcrStatus`);
};

/**
 * 上传PDF并执行OCR识别（不保存到数据库）
 * @param {FormData} formData 包含file字段的FormData
 * @returns
 */
export const ocrPdf = (formData) => {
  return postFile(`yj/work-add/ocrPdf`, formData);
};

// 导出合同数据到Excel
export function exportContractXLS(params) {
  return axios({
    url: '/yj/work/exportXLS',
    method: 'get',
    params: params,
    responseType: 'blob', // 重要：指定响应类型为blob
    timeout: 300000 // 5分钟超时，因为导出可能需要较长时间
  }).then(response => {
    // 检查响应类型，如果返回的是JSON错误，需要特殊处理
    const contentType = response.headers['content-type'] || response.headers['Content-Type'] || '';
    
    if (contentType.includes('application/json')) {
      // 如果返回的是JSON，说明是错误响应，需要解析
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result);
            reject({
              response: {
                data: errorData,
                status: response.status,
                statusText: response.statusText,
                headers: response.headers
              }
            });
          } catch (e) {
            reject({
              response: {
                data: { code: -1, msg: '导出失败，无法解析错误信息' },
                status: response.status,
                statusText: response.statusText,
                headers: response.headers
              }
            });
          }
        };
        reader.onerror = () => {
          reject({
            response: {
              data: { code: -1, msg: '导出失败，读取响应失败' },
              status: response.status,
              statusText: response.statusText,
              headers: response.headers
            }
          });
        };
        reader.readAsText(response.data);
      });
    }
    
    // 检查blob大小，如果为0可能是错误
    if (response.data && response.data.size === 0) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result);
            reject({
              response: {
                data: errorData,
                status: response.status,
                statusText: response.statusText,
                headers: response.headers
              }
            });
          } catch (e) {
            // 如果解析失败，可能是真的空文件
            resolve(response);
          }
        };
        reader.onerror = () => {
          resolve(response);
        };
        reader.readAsText(response.data);
      });
    }
    
    // 正常返回blob响应
    return response;
  }).catch(error => {
    // 确保错误对象有正确的结构
    if (!error.response) {
      // 网络错误或超时
      const errorMessage = error.code === 'ECONNABORTED' 
        ? '导出超时，请稍后重试' 
        : (error.message || '导出失败，网络错误');
      return Promise.reject({
        response: {
          data: { code: -1, msg: errorMessage },
          status: 0,
          statusText: error.code === 'ECONNABORTED' ? 'Timeout' : 'Network Error'
        },
        message: error.message,
        code: error.code
      });
    }
    return Promise.reject(error);
  });
}


// 在api.js中添加下载附件的方法
/**
 * 下载附件（GET）
 * 需传入的参数
 * id: 合同ID
 * @param {URLSearchParams} params
 * @returns
 */
export const downloadAttachment = (params) => getFile(`yj/work/downloadAttachment`, params);

// =====================================================================> 新增：合同完成状态管理 API
/**
 * 确认合同完成（POST）
 * 需传入的参数
 * id: 合同ID
 * @param {URLSearchParams} params
 * @returns
 */
export const completeWork = (params) => post(`yj/work/complete`, params);

/**
 * 撤销合同完成状态（POST）
 * 需传入的参数
 * id: 合同ID
 * @param {URLSearchParams} params
 * @returns
 */
export const undoCompleteWork = (params) => post(`yj/work/undoComplete`, params);

// api.js 中添加
/**
 * 获取公司历史记录（GET）
 * 需传入的参数
 * type: "build" 或 "win"
 * keyword: 搜索关键词
 * @param {URLSearchParams} params
 * @returns
 */
export const getCompanyHistory = (params) => get(`yj/work/companyHistory`, params);

// 在 api.js 中添加以下方法

/**
 * 上传附件（POST）
 * 需传入的参数
 * contractId: 合同ID
 * file: (二进制)
 * @param {FormData} data
 * @returns
 */
export const uploadAttachment = (data) => postFile(`yj/work/uploadAttachment`, data);

/**
 * 查看附件（GET）
 * 需传入的参数
 * contractId: 合同ID
 * @param {URLSearchParams} params
 * @returns
 */
export const viewAttachment = (params) => getFile(`yj/work/viewAttachment`, params);

/**
 * 删除附件（POST）
 * 需传入的参数
 * contractId: 合同ID
 * @param {URLSearchParams} params
 * @returns
 */
export const deleteAttachment = (params) => post(`yj/work/deleteAttachment`, params);

// =====================================================================> 学生信息管理 API
/**
 * 初始化查询参数（GET）
 * 返回的参数有
 * grade：年级列表
 * major：专业列表
 * @returns
 */
export const initManageStu = () => get(`yj/student-management`);

/**
 * 获取学生列表（GET）
 * 需传入的参数
 * limit: 每页的记录条数
 * page: 当前页码
 * gradeId: 年级id（可选）
 * majorId: 专业id（可选）
 * classId: 班级id（可选）
 * keyUsername: 学号（可选）
 * keyName: 姓名（可选）
 * order: 排序方式（可选）
 * field: 排序字段（可选）
 * @param {URLSearchParams} params
 * @returns
 */
export const getStuList = (params) =>
  get(`yj/student-management/list`, params);

/**
 * 重置密码
 * 请求方法: POST
 * ids[]: 2636
 */
export const resetStuPass = (params) =>
  post(`yj/student-management/reset`, params);

/**
 * 删除学生
 * 请求方法: POST
 * studentNos[]: 10419832
 */
export const delStu = (params) => post(`yj/student-management/delete`, params);

/**
 * 更新学生信息
 * 请求方法: POST
 * modifiedField: majorName
 * stuNo: 10419832
 * newName: 赖志豪
 * newGradeId: 2021
 * newMajorName: 计算机科学与技术
 * newClassNo: 8
 */
export const updateStu = (params) =>
  post(`yj/student-management/update`, params);

// =====================================================================> 教师信息管理 API
/**
 * 初始化查询参数（GET）
 * 返回的参数有
 * grade：年级列表
 * major：专业列表
 * role：角色列表
 * @returns
 */
export const initManageTea = () => get(`yj/teacher-management`);

/** 获取部门列表（GET），返回 [{ id, name }] */
export const getDepartmentList = () => get(`yj/teacher-management/departmentList`);

/**
 * 获取教职工列表（GET）
 * 需传入的参数
 * limit: 每页的记录条数
 * page: 当前页码
 * keyUsername: 教职工号（可选）
 * keyName: 姓名（可选）
 * order: 排序方式（可选）
 * field: 排序字段（可选）
 * @param {URLSearchParams} params
 * @returns
 */
export const getTeaList = (params) =>
  get(`yj/teacher-management/list`, params);

/**重置密码
 *
 * 请求 URL: http://localhost/yj/teacher-management/reset
 * 请求方法: POST
 * ids[]: 2636
 */
export const resetTeaPass = (params) =>
  post(`yj/teacher-management/reset`, params);

/**
 * 删除教师
 * 请求方法: POST
 * teacherNos[]: 69119132
 */
export const delTea = (params) => post(`yj/teacher-management/delete`, params);

/**更新教师信息
 * 请求方法: POST
 * username: 999100236
 * newName: 凌明1
 */
export const updateTea = (params) =>
  post(`yj/teacher-management/update`, params);

/**
 * 设置教师
 * 请求方法: POST
 * ids[]: 63
 * classIds[]: 140
 * classIds[]: 141
 * classIds[]: 142
 * classIds[]: 143
 * classIds[]: 144
 * usernames[]: 999100235
 * roleId: 3
 * oldroleIds[]: 3
 * 设置其他角色
 * ids[]: 91
 * usernames[]: 999100236
 * roleId: 2
 * oldroleIds[]: 3
 */
export const setRole = (params) =>
  post(`yj/teacher-management/setRole`, params);

/**
 * 新增用户（员工）
 * POST yj/teacher-management/add
 * username: 账号（11位）；密码默认为账号，无需传
 * name: 姓名
 * genderId: 性别（1 男 2 女）
 * roleId: 角色 id（2=用户等，不可选 1 管理员、3 学生）
 */
export const addTeacher = (params) =>
  post(`yj/teacher-management/add`, params);

/** 更新员工角色与部门（员工管理 - 设置权限） */
export const updateRoleAndDepartment = (params) =>
  post(`yj/teacher-management/updateRoleAndDepartment`, params);

/** 仅更新用户部门（用于编辑时为管理员设置部门） */
export const updateUserDepartment = (params) =>
  post(`yj/teacher-management/updateUserDepartment`, params);

/** 新增部门 */
export const addDepartment = (params) =>
  post(`yj/teacher-management/addDepartment`, params);

/** 更新部门名称 */
export const updateDepartment = (params) =>
  post(`yj/teacher-management/updateDepartment`, params);

/** 删除部门 */
export const deleteDepartment = (params) =>
  post(`yj/teacher-management/deleteDepartment`, params);

// =====================================================================> 教师导入页 API
/**
 * 下载教师模板
 * @returns
 */
export const getTeaTemplate = () => getFile(`yj/import-tea/download`);

/**
 * 上传教师（POST）
 * 需传入的参数
 * file: (二进制)
 * @param {FormData} data
 * @returns
 */
export const uploadTeaTemplate = (data) =>
  postFile(`yj/import-tea/upload`, data);

// =====================================================================> 合同导入页 API
/**
 * 下载合同模板
 * @returns
 */
export const getHetongTemplate = () => getFile(`yj/import-hetong/download`);

/**
 * 上传合同（POST）
 * 需传入的参数
 * file: (二进制)
 * @param {FormData} data
 * @returns
 */
export const uploadHetongTemplate = (data) =>
  postFile(`yj/import-hetong/upload`, data);


// 合同申请相关API
// 检查合同是否可以申请修改
export const checkContractApplyable = (params) =>
  get(`yj/contractApply/checkApplyable`, params);

// 提交合同修改申请

export function submitContractApply(data) {
  // 直接使用 post，而不是 postFile
  return post('/yj/contractApply/createApply', data);
}

// 撤回申请
export const withdrawContractApply = (params) =>
  post(`yj/contractApply/withdrawApply`, params);

// 获取申请列表
export const getContractApplyList = (params) =>
  get(`yj/contractApply/list`, params);

// 获取申请详情
export const getContractApplyDetail = (params) =>
  get(`yj/contractApply/detail`, params);

// 审批相关API
// 审批通过
export const approveContractApply = (data) =>
  post(`yj/contractApprove/approve`, data);

// 审批拒绝
export const rejectContractApply = (data) =>
  post(`yj/contractApprove/reject`, data);

// 生效申请
export const effectContractApply = (data) =>
  post(`yj/contractApprove/effect`, data);

// 获取待审批列表
export const getPendingApproveList = (params) =>
  get(`yj/contractApprove/pendingList`, params);


